// type Period = 'day' | 'week' | 'month' | 'year' | 'custom';
import { endOfToday, startOfDay, subDays } from 'date-fns';
/** The only use case is inside *yup*'s **oneOf** validator */
export const namedPeriods = ['day', 'week', 'month', 'year', 'custom'];
export const customPeriodDefaultDateFrom = startOfDay(subDays(new Date(), 13));
export const customPeriodDefaultDateTo = endOfToday();
